import { AxiosRequest } from "../common/axios-request"
import { FACILITY_AVAILABILITY_CHECK, GET_BOOKING_SUMMARY_SPORTWISE, GET_BOOKING_SUMMARY_TYPEWISE, GET_DASHBOARD_COUNT, GET_EXIT_BOOKING_LIST, GET_NOTIFICATION_COUNT, GET_REVENUE_SUMMARY_SPORTWISE, GET_REVENUE_SUMMARY_TYPEWISE, GET_USER_NOTIFICATION } from "../common/constant"

const GetDashboardCount = () => {
    return AxiosRequest.get(GET_DASHBOARD_COUNT)
}

const GetBookingSummaryTypewise = (fromDate: string, toDate: string, facilityId: string) => {
    return AxiosRequest.get(GET_BOOKING_SUMMARY_TYPEWISE(fromDate, toDate, facilityId))
}

const GetBookingSummarySportWise = (fromDate: string, toDate: string, facilityId: string) => {
    return AxiosRequest.get(GET_BOOKING_SUMMARY_SPORTWISE(fromDate, toDate, facilityId))
}

const GetRevenueSummaryTypewise = (fromDate: string, toDate: string, facilityId: string) => {
    return AxiosRequest.get(GET_REVENUE_SUMMARY_TYPEWISE(fromDate, toDate, facilityId))
}

const GetRevenueSummarySportWise = (fromDate: string, toDate: string, facilityId: string) => {
    return AxiosRequest.get(GET_REVENUE_SUMMARY_SPORTWISE(fromDate, toDate, facilityId))
}

const GetExitBookingList = (minutes: string, facilityId: string) => {
    return AxiosRequest.get(GET_EXIT_BOOKING_LIST(minutes, facilityId))
}

const GetFacilityAvailabilityCheckList = (facilityId: string, sportId: string, startDate: string, endDate: string, startTime: string, endTime: string) => {
    return AxiosRequest.get(FACILITY_AVAILABILITY_CHECK(facilityId, sportId, startDate, endDate, startTime, endTime))
}

const GetUserNotification = (page: any = 1) => {
    return AxiosRequest.get(GET_USER_NOTIFICATION(page))
}

const GetNotificationCount = () => {
    return AxiosRequest.get(GET_NOTIFICATION_COUNT)
}

export { GetDashboardCount, GetBookingSummaryTypewise, GetBookingSummarySportWise, GetRevenueSummaryTypewise, GetRevenueSummarySportWise, GetExitBookingList, GetFacilityAvailabilityCheckList, GetUserNotification, GetNotificationCount }